import Vue from "vue";
import Vuex from "vuex";
import api from "@/api";
import http from "@/api/http";
import createPersistedState from "vuex-persistedstate";
import { cartManager } from "@/utilities";
import i18n from '@/i18n'
import _ from "lodash";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: {
      user: null,
      token: localStorage.getItem("user-token") || null,
    },
    config: {
      api_key: localStorage.getItem("api-key") || null,
    },
    theme: {},
    locations: [],
    business: {},
    categories: [],
    postBody: {},
    orderTotal: 0,
    selectedLocation: {},
    avilableLocations: [],
    favorites: [],
    locationReviews: [],
    guestData: null,
    isLoadingCategories: false,
    trackingStatus:null,
    currentLanguage:null, 
    isUKApp : true,
    currentCurrency : '£',
    nativeApplePayStatus: null,
    nativeGooglePayStatus: null,
    channel: 4, // default value for the web browsers
    trackedOrders: [],
    oneSignalUserId:null, // default
    oneSignalPlayerId:null,
    storeLinks:null,
    providerName:null
  },
  plugins: [createPersistedState()],
  mutations: {
    setApiKey: (state, apiKey) => {
      state.config.api_key = apiKey;
      /* Add Api Key Header to http */
      http.defaults.headers.common["ApiKey"] = apiKey;
      localStorage.setItem("api-key", apiKey);
    },
    setTheme: (state, theme) =>
      Vue.set(state, "theme", Object.assign({}, theme)),
    setLocations: (state, locations) => Vue.set(state, "locations", locations),
    setSearchedLocations: (state, avilableLocations) =>
      Vue.set(state, "avilableLocations", avilableLocations),
    setBusiness: (state, business) =>
      Vue.set(state, "business", Object.assign({}, business)),
    setCategories: (state, payload) =>{
      if(!state.categories || _.isObject(state.categories) || (state.categories.length && !state.categories[0].new_format)){
        Vue.set(state, "categories", [])
      }
      const existsAtIndex = state.categories.findIndex(o => o.location_id === payload.location_id)
      if(existsAtIndex != -1){
        state.categories[existsAtIndex] = payload
      }else{
        state.categories.unshift(payload) // insert the element to the begining of the array
      } 
    }  ,
    authSuccess: (state, res) => {
      state.auth.token = res.token;
      state.auth.user = res;
      localStorage.setItem("user-token", res.token);
      http.defaults.headers.common["Authorization"] = "Bearer " + res.token;
    },
    authFailed: (state) => {
      state.auth.token = null;
      state.auth.user = null;
      localStorage.removeItem("user-token");
      cartManager.clearCart();
      state.userReviews = null;
      state.locationReviews = null;
      state.userCards = null;
      state.trackedOrders = []
      state.oneSignalUserId = null;
      state.oneSignalPlayerId = null;
      state.providerName = null;
      delete http.defaults.headers.common["Authorization"];
    },
    setAuthUser: (state, user) => {
      state.auth.user = user;
    },
    setDocs: (state, docs) => {
      state.docs = docs;
    },
    setUserCards: (state, userCards) => {
      state.userCards = userCards;
    },
    setOrderTotal: (state, _orderTotal) => {
      state.orderTotal = _orderTotal;
    },
    setSelectedLocation: (state, _selectedLocation) => {
      state.selectedLocation = _selectedLocation;
      state.currentCurrency = _selectedLocation && _selectedLocation.currency ? _selectedLocation.currency.raw_symbol : "£";
    },
    setLocationReviews: (state, reviews) => {
      state.locationReviews = reviews;
    },
    setUserReviews: (state, userReviews) => {
      state.userReviews = userReviews;
    },
    setGuestData: (state, _guestData) => {
      state.guestData = _guestData;
    },
    setIsLoadingCategories: (state, isLoading) =>{
      state.isLoadingCategories = isLoading
    },
    setTrackingStatus:(state, statusValue)=>{
      state.trackingStatus = statusValue
    },
    setCurrentLangauge:(state, code) => {
      i18n.locale = code;
      state.currentLanguage = code
    },
    setIsUKApp:(state, isUK) => {
      state.isUKApp = isUK
    },
    setNativeApplePayStatus:(state,value)=>{
      state.nativeApplePayStatus = value
    },
    setNativeGooglePaystatus:(state, value) =>{
      state.nativeGooglePayStatus = value
    },
    setChannel:(state, _channel)=>{
      state.channel = _channel
    },
    setTreckedOrder:(state, payload) =>{
      const existsAtIndex = state.trackedOrders.findIndex(o => o.id === payload.id)

      if(existsAtIndex != -1){
        state.trackedOrders[existsAtIndex] = payload
      }else{
        state.trackedOrders.unshift(payload) // insert the element to the begining of the array
      }
    },
    setOneSignalUserId:(state, userId)=>{
      state.oneSignalUserId = userId;
    },
    setOneSignalPlayerId:(state, playerId)=>{
      state.oneSignalPlayerId = playerId;
    },
    setStoreLinks:(state, payload)=>{
      state.storeLinks = payload
    },
    setProviderName: (state, provider) =>{
      state.providerName = provider;
    }
  },
  getters: {
    isAuthenticated: (state) => !!state.auth.token && !!state.auth.user,
    guestData: (state) => state.guestData,
    getLocationBySlug: (state) => (location) => {
      return state.locations.find((loc) => loc.slug === location);
    },
    getCategoryById: (state) => (categoryId) => {
      if (categoryId > 0)
        return state.categories.find((cat) => cat.id === categoryId);
      else return state.categories[0];
    },
    isLoadingCategories:(state)=> { return state.isLoadingCategories },
    getTrackingStatus:(state) =>{ return state.trackingStatus },
    getCurrentLanguage:(state) => { return state.currentLanguage },
    getIsUKApp:(state) => { return state.isUKApp },
    getNativeApplePayStatus:(state) => { return state.nativeApplePayStatus},
    getNativeGooglePayStatus:(state) => { return state.nativeGooglePayStatus},
    getChannel:(state) => { return state.channel},
    getTrackedOrder:(state) => { return state.trackedOrders },
    getOneSignalUserId:(state)=>{return state.oneSignalUserId},
    getOneSignalPlayerId:(state)=>{return state.oneSignalPlayerId},
    getStoreLinks :(state)=> { return state.storeLinks},
    getProviderName:(state) => {return state.providerName},
    getBusiness: (state)=> { return state.business},
    getCategories: (state)=> { return state.categories}
  },
  actions: {
    fetchTheme: ({ commit, state }, data) => {
      return new Promise((resolve, reject) => {
        api.init
          .website(data)
          .then((response) => {
            /* set the ApiKey in store */
            commit("setApiKey", response.data.api_key);
            commit("setTheme", response.data.theme);
            commit("setLocations", response.data.locations);
            commit("setSearchedLocations", response.data.locations);
            commit("setBusiness", response.data.business);
            commit("setStoreLinks", {
              appStore: response.data.app_store_link,
              playStore: response.data.google_play_link
            })
            if (response.data.locations.length == 1){
              commit("setSelectedLocation", response.data.locations[0]);
            }  
            else if (state.selectedLocation) {
              commit(
                "setSelectedLocation",
                response.data.locations.find(
                  (l) => l.id == state.selectedLocation.id
                )
              );
            }

            if(!state.currentLanguage ) {
              if(response.data.business) {
                  commit("setCurrentLangauge", response.data.business.territory.toLowerCase())
              }else{
                commit("setCurrentLangauge", "en")
              }
            }

            commit("setIsUKApp", response.data.business.territory.toLowerCase()  == "en" );

            resolve();
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    authRequest: ({ commit, dispatch }, { email, password }) => {
      return new Promise((resolve, reject) => {
        api.auth
          .login(email, password)
          .then((response) => {
            commit("authSuccess", response.data);
            dispatch("fetchAuthUser");
            resolve(response);
          })
          .catch((e) => {
            commit("authFailed");
            reject(e.response);
          });
      });
    },
    authSocialRequest: ({ commit, dispatch }, payload) => {
      return new Promise((resolve, reject) => {
        api.auth
          .socialLogin(payload)
          .then((response) => {
            if(response.config.data){
              try{
                const data = JSON.parse(response.config.data);
                commit('setProviderName', data.provider_name)
              }catch(e){}
            }
            commit("authSuccess", response.data);
            dispatch("fetchAuthUser");
            resolve(response);
          })
          .catch((e) => {
            commit("authFailed");
            reject(e.response);
          });
      });
    },
    fetchAuthUser: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        api.auth
          .user()
          .then((res) => {
            commit("setAuthUser", res.data);
            dispatch("fetchUserCardsRequest");
            resolve();
          })
          .catch((e) => {
            commit("authFailed");
            reject(e.response);
          });
      });
    },
    updateUserRequest: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.auth
          .userUpdate(data)
          .then((response) => {
            commit("setAuthUser", response.data);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    logoutRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.auth
          .logout()
          .then(() => {
            commit("authFailed");
            resolve();
          })
          .catch((e) => {
            commit("authFailed");
            reject(e.response);
          });
      });
    },
    fetchCategories: ({ commit }, idLocation) => {
      return new Promise((resolve, reject) => {
        commit("setIsLoadingCategories", true)
        api.locations
          .categories(idLocation)
          .then((response) => {
            commit("setCategories", {location_id: idLocation, categories: response.data, new_format: true});
            resolve(response.data);
          })
          .catch((e) => {
            /* TODO: handle error */
            commit("setCategories", {location_id: idLocation, categories: [], new_format: true});
            reject(e.response);
          }).finally(()=>{
            commit("setIsLoadingCategories", false)
          })
      });
    },
    fetchLocation: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        api.locations
          .location(data.id, data)
          .then((response) => {
            commit("setSelectedLocation", response.data);
            resolve(response.data);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    addNewAddress: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .postNewAddress(data)
          .then((res) => {
            dispatch("fetchAuthUser");
            resolve(res);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    primaryAddressRequest: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .primaryAddress(data)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    deleteAddress: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .postdeleteAddress(data)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    updateAddressRequest: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.address
          .updateAddress(data)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve(data);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    getPublicDocsRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.publicdocs
          .getPublicDocuments()
          .then((response) => {
            commit("setDocs", response.data);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    fetchUserCardsRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.card
          .getCards()
          .then((res) => {
            commit("setUserCards", res.data);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    addUserCardRequest: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.card
          .addUserCard(data)
          .then(() => {
            dispatch("fetchUserCardsRequest");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    deleteUserCardRequest: ({ dispatch }, idCard) => {
      return new Promise((resolve, reject) => {
        api.card
          .deleteCard(idCard)
          .then(() => {
            dispatch("fetchAuthUser");
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    addToFavorite: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.favorit
          .postToFavorite(data)
          .then(() => {
            dispatch("fetchCategories", data.location_id);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    deleteFavorite: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        api.favorit
          .deleteUserFavorite(data.menu_item_id, data.location_id)
          .then(() => {
            dispatch("fetchCategories", data.location_id);
            resolve();
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    fetchLocationsByPostCode: ({ commit }, postcode) => {
      return new Promise((resolve, reject) => {
        api.locations
          .search(postcode)
          .then((result) => {
            commit("setSearchedLocations", result.data.data);
            resolve(result);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    storeOrderTotal: ({ commit }, _orderTotal) => {
      commit("setOrderTotal", _orderTotal);
    },
    storeSelectedLocation: ({ commit }, _location) => {
      commit("setSelectedLocation", _location);
    },
    storeGuestData: ({ commit }, data) => {
      commit("setGuestData", data);
    },
    /*****************************Reviews*****************************/
    fetchLocationReviews: ({ commit }, id) => {
      return new Promise((resolve, reject) => {
        api.reviews
          .getLocationReviews(id)
          .then((result) => {
            commit("setLocationReviews", result.data);
            resolve(result);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    getUserReviewsRequest: ({ commit }) => {
      return new Promise((resolve, reject) => {
        api.reviews
          .getUserReviews()
          .then((response) => {
            commit("setUserReviews", response.data);
            resolve(response);
          })
          .catch((e) => {
            reject(e.response);
          });
      });
    },
    saveTrackingStatus : ({commit}, status) => {
      commit("setTrackingStatus" , status);
    },
    swicthLanguage : ({commit}, code) => {
      commit("setCurrentLangauge" , code);
    },
    saveApplePayAvailibility:({commit}, value)=>{
      commit("setNativeApplePayStatus", value)
    },
    saveGooglePayAvailibility:({commit}, value)=>{
      commit("setNativeGooglePaystatus", value)
    },
    saveChannel:({commit}, channel)=>{
      commit('setChannel', channel)
    },
    saveTrackedOrder:({commit}, payload)=>{
      commit('setTreckedOrder', payload)
    },
    saveOneSignalUserId:({commit}, userId)=>{
      commit('setOneSignalUserId', userId)
    },
    saveOneSignalPlayerId:({commit}, playerId)=>{
      commit('setOneSignalPlayerId', playerId)
    },
  },
});
